<section class="wrap">
  <div class="login">
    <app-form-sign-in [title]="'Connexion espace professionnel'" [action]="'admin'" component="openDialog">
    </app-form-sign-in>
  </div>
</section>
